import React from 'react';
import {connect} from 'react-redux';
import {Link, Route, Switch} from 'react-router-dom';
import {bindActionCreators} from "redux";

import {fetchCurrentUser} from "../../../creators/currentUser";

import GeneralSettings from './components/SettingProfile';
import PasswordEmail from './components/PasswordEmail';
import Signature from './components/Signature';
import Blocked from './components/Blocked';
import NotificationSettings from './components/NotificationSettings';
import Acquaintance from './components/FriendsAndRequest';
import Subscription from "./components/Subscription";
import ProfilMeetSettings from "./components/ProfilMeetSettings";
import ProfilSettings from "./components/ProfilSettings";
import {PageLoader} from "../../components/Loader";
import createLink from "../../../libs/createLink";


class Settings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            currentUser: {},
        };
        this.handleChangeIndex = this.handleChangeIndex.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFriend = this.handleFriend.bind(this);
        this.handleLastVisitor = this.handleLastVisitor.bind(this);
        this.handleComment = this.handleComment.bind(this);
        this.handleLocation = this.handleLocation.bind(this);
        this.handleInformations = this.handleInformations.bind(this);
        this.handleProfile = this.handleProfile.bind(this);
        this.handleUpdateEmail = this.handleUpdateEmail.bind(this);
        this.handleUpdatePassword = this.handleUpdatePassword.bind(this);
        this.handleDate = this.handleDate.bind(this);
        this.handleSignature = this.handleSignature.bind(this);
        this.handleSignatureDisplay = this.handleSignatureDisplay.bind(this);
    }

    componentWillMount() {
        this.setState({currentUser: {...this.props.currentUser}});
    }

    componentDidUpdate(nextProps) {
        if (nextProps.currentUser._id !== this.props.currentUser._id) {
            this.setState({currentUser: nextProps.currentUser});
        }
    }

    handleChangeIndex(index) {
        this.props.resetUpdateMe();
        this.setState({currentIndex: index, currentUser: {...this.props.currentUser}})
    }

    handleInformations(key, value) {
        this.setState({currentUser: {...this.state.currentUser, [key]: value}});
    }

    handleFriend() {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                friend: {...this.state.currentUser.friend, display: !this.state.currentUser.friend.display}
            }
        });
    }

    handleLastVisitor() {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                lastVisitor: {
                    ...this.state.currentUser.lastVisitor,
                    display: !this.state.currentUser.lastVisitor.display
                }
            }
        });
    }

    handleComment(key, value) {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                profile: {
                    ...this.state.currentUser.profile,
                    comment: {...this.state.currentUser.profile.comment, [key]: value}
                }
            }
        });
    }

    handleLocation(key, value) {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                location: {...this.state.currentUser.location, [key]: value}
            }
        });
    }

    handleProfile(event) {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                profile: {...this.state.currentUser.profile, [event.target.name]: event.target.value}
            }
        });
    }

    handleDate(date, index = 0) {
        let birthday = this.state.currentUser.profile.birthday;
        birthday[index] = date;
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                profile: {...this.state.currentUser.profile, birthday: birthday}
            }
        });
    }

    handleSignature(content) {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                profile: {
                    ...this.state.currentUser.profile,
                    signature: {...this.state.currentUser.profile.signature, content: content}
                }
            }
        });
    }

    handleSignatureDisplay() {
        this.setState({
            currentUser: {
                ...this.state.currentUser,
                profile: {
                    ...this.state.currentUser.profile,
                    signature: {
                        ...this.state.currentUser.profile.signature,
                        display: !this.state.currentUser.profile.signature.display
                    }
                }
            }
        });
    }


    handleSubmit() {
        let currentUser = this.state.currentUser;
        this.props.updateMe(currentUser);
    }

    handleUpdateEmail(currentUser = false) {
        if (currentUser) {
            this.props.updateMeEmail(currentUser);
        }
    }

    handleUpdatePassword(currentUser = false) {
        if (currentUser) {
            this.props.updateMePassword(currentUser);
        }
    }


    render() {
        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <div id="settings">
                <div className="container">
                    <div className="card big">
                        <div className="layout-sidebar">
                            <div className="sidebar">
                                <div className="topline">
                                    <ul className="sidebar-menu">
                                        <Link to={createLink('userMeSettings')}
                                              className={`${this.props.location.pathname === createLink('userMeSettings') ? 'active' : ''} side-menu-item`}>Mon
                                            profil</Link>
                                        <Link to={`${createLink('userMeSettingsDating')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsDating')}` ? 'active' : ''} side-menu-item`}>Rencontre</Link>
                                        <div className={"separator"} />
                                        <Link to={`${createLink('userMeSettingsProfile')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsProfile')}` ? 'active' : ''} side-menu-item`}>Paramètres de profil</Link>
                                        <Link to={`${createLink('userMeSettingsFriendsAndRequest')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsFriendsAndRequest')}` ? 'active' : ''} side-menu-item`}>Amis
                                            et Demandes</Link>
                                        <Link to={`${createLink('userMeSettingsEmailAndPassword')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsEmailAndPassword')}` ? 'active' : ''} side-menu-item`}>Email
                                            & mot de passe</Link>
                                        <Link to={`${createLink('userMeSettingsSignature')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsSignature')}` ? 'active' : ''} side-menu-item`}>Signature</Link>
                                        <Link to={`${createLink('userMeSettingsBlocage')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsBlocage')}` ? 'active' : ''} side-menu-item`}>Préférence
                                            de blocage</Link>
                                        <Link to={`${createLink('userMeSettingsOptionsNotifications')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsOptionsNotifications')}` ? 'active' : ''} side-menu-item`}>Options
                                            de Notifications</Link>
                                        <Link to={`${createLink('userMeSettingsAbonnement')}`}
                                              className={`${this.props.location.pathname === `${createLink('userMeSettingsAbonnement')}` ? 'active' : ''} side-menu-item`}>Abonnement
                                            / Certification</Link>
                                    </ul>
                                </div>
                            </div>
                            <div className="main-wrapper">
                                {/*{!this.props.updateError.loading && this.props.updateError.error.status===null && (<div className="update-done"><span className="valide">Vos données ont bien été mise à jours <Icon type="check-circle" /></span></div>)}*/}
                                {/*{!this.props.updateError.loading && this.props.updateError.error.status!==null && (<div className="update-done"><span className="warning">Mise a jour impossible <Icon type="close" /></span></div>)}*/}
                                <Switch>
                                    <Route path={`${createLink('userMeSettingsProfile')}`} exact
                                           render={(props) => <GeneralSettings currentUser={this.state.currentUser}
                                                                               handleSubmit={this.handleSubmit}
                                                                               handleLastVisitor={this.handleLastVisitor}
                                                                               handleComment={this.handleComment}/>}/>
                                    <Route path={createLink('userMeSettings')} exact render={(props) => <ProfilSettings/>}/>
                                    <Route path={`${createLink('userMeSettingsDating')}`} exact
                                           render={(props) => <ProfilMeetSettings/>}/>
                                    <Route path={`${createLink('userMeSettingsFriendsAndRequest')}`} exact
                                           render={(props) => <Acquaintance currentUser={this.state.currentUser}
                                                                            handleSubmit={this.handleSubmit}
                                                                            handleFriend={this.handleFriend}
                                                                            handleLastVisitor={this.handleLastVisitor}
                                                                            handleComment={this.handleComment}/>}/>
                                    <Route path={`${createLink('userMeSettingsEmailAndPassword')}`}exact
                                           render={(props) => <PasswordEmail currentUser={this.state.currentUser}
                                                                             handleUpdateEmail={this.handleUpdateEmail}
                                                                             handleUpdatePassword={this.handleUpdatePassword}
                                                                             updateError={this.props.updateError}/>}/>
                                    <Route path={`${createLink('userMeSettingsSignature')}`} exact
                                           render={(props) => <Signature currentUser={this.state.currentUser}
                                                                         handleSignature={this.handleSignature}
                                                                         handleSubmit={this.handleSubmit}
                                                                         handleSignatureDisplay={this.handleSignatureDisplay}/>}/>
                                    <Route path={`${createLink('userMeSettingsBlocage')}`} exact
                                           render={(props) => <Blocked currentUser={this.state.currentUser}/>}/>
                                    <Route path={`${createLink('userMeSettingsOptionsNotifications')}`} exact
                                           render={(props) => <NotificationSettings currentUser={this.state.currentUser} />}/>
                                    <Route path={`${createLink('userMeSettingsAbonnement')}`} exact
                                           render={(props) => <Subscription currentUser={this.state.currentUser}
                                                                            handleSubmit={this.handleSubmit}/>}/>
                                </Switch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
